<template>
  <div id="app">

    <LoginFinder/>
  </div>
</template>

<script>
import LoginFinder from './components/LoginFinder'

export default {
  name: 'App',
  components: {
    LoginFinder
  }
}
</script>

<style>
body {
  background-image:url('https://www.d2l.com/wp-content/themes/bigdrop-theme/dist-new/images/bg-waves.svg');
  background-color: #f7fafe;
  background-position: top center;
  background-repeat: no-repeat;
  color: #131820;
}
#app {
  margin-top: 25px;
}

div.bot.avatar:before {
  background: url('./assets/bot-avatar.png');
}
</style>



// WEBPACK FOOTER //
// src/App.vue